import { useEffect, useMemo, useState } from "react";
import { Box, Stack, TextField, Button, Typography } from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";


import BreadcrumbsBar from "../../../../../component/common/BreadcrumbsBar";
//import PageHeader from "../../../../component/common/PageHeader";

import ReportContainer from "../../../component/ReportContainer";
import ReportHeader from "../../../component/ReportHeader";
import ReportToolbar from "../../../component/ReportToolbar";
import ReportTitle from "../../../component/ReportTitle";
import ReportActions from "../../../component/ReportActions";
import ReportLoading from "../../../component/ReportLoading";
import ReportNoData from "../../../component/ReportNoData";
import { MenuItem } from "@mui/material";
import WGRViewer from "./uocViewer";
import { uoProcedure } from "../../../../../services/reportService";

import generateWGRPDF from "./pdfreport/uocgeneratePDF";

import { useLocation } from "react-router-dom";

import SearchIcon from "@mui/icons-material/Search";
const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export default function POHPage() {





  const location = useLocation();

  const report = location.state || {
    reportType: "Under Over Charge",
    title: "Under Over Charge",
  };

  const { reportType, title } = report;

  const today = new Date();



  const month = location.state.month;
  const year = location.state.year;




  const [rows, setRows] = useState([]);


const [allocationRows, setAllocationRows] = useState([]);



  const [loading, setLoading] = useState(false);

  const monthName = useMemo(
    () => months[month - 1],
    [month]
  );

  const loadReport = async () => {
    try {
      setLoading(true);

      const res = await uoProcedure(month, year);

      setRows(res.data.data || []);

      //console.log(res.data.data[0]);




    } catch (err) {
      console.error(err);
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  const handleRefresh = () => {
    loadReport();
  };

  const handlePrint = () => {
    window.print();

    setTimeout(() => {
      setRows([]);
    }, 500);
  };



  /*
     * Grand Total
     */
  const grandTotal = useMemo(() => {
  const result = {
    mechanical: {
      A: 0,
      B: 0,
      C: 0,
      D: 0,
    },

    electrical: {
      A: 0,
      B: 0,
      C: 0,
      D: 0,
    },

    total: {
      A: 0,
      B: 0,
      C: 0,
      D: 0,
    },
  };

  rows.forEach((row) => {
    const department = String(
      row["DIVISIONTYPE"] || ""
    ).trim().toLowerCase();

    const A = Number(
      row["U/O CHARGE LABOUR ON COST (A)"] || 0
    );

    const B = Number(
      row["ENGA - TIMESHEET(B)"] || 0
    );

    const C = Number(
      row["TOTAL OF A+B"] || 0
    );

    const D = Number(
      row["U/O ON COST STORE"] || 0
    );

    // Separate department data
    if (department === "mechanical") {
      result.mechanical.A = A;
      result.mechanical.B = B;
      result.mechanical.C = C;
      result.mechanical.D = D;
    }

    if (department === "electrical") {
      result.electrical.A = A;
      result.electrical.B = B;
      result.electrical.C = C;
      result.electrical.D = D;
    }

    // Grand totals
    result.total.A += A;
    result.total.B += B;
    result.total.C += C;
    result.total.D += D;
  });

  return result;
}, [rows]);




  const handlePdf = () => {
    generateWGRPDF(
      reportType,
      title,
      grandTotal,
      rows,
      "",
      monthName,

      year
    );
  };

  const handleExcel = () => {
    console.log("Generate Excel");
  };


  useEffect(() => {
    // Optional: Clear previous report
    setRows([]);

    // Load report if you want automatically
    loadReport();

  }, [reportType]);




  return (
    <Box >

      <BreadcrumbsBar page={title} />


      {/* Search Panel */}




      {/* Report */}

      <ReportContainer>


        <ReportToolbar>

          <ReportTitle
            title={title}
            subtitle={`${monthName} ${year}`}
          />

          <Box className="no-print">
            <ReportActions
              onRefresh={handleRefresh}
              onPrint={handlePrint}
              onPdf={handlePdf}
              onExcel={handleExcel}
            />
          </Box>



        </ReportToolbar>

        {loading ? (
          <ReportLoading />
        ) : rows.length === 0 ? (
          <ReportNoData text="Click Generate to view report." />
        ) : (
          <WGRViewer
            rows={rows}
            grandTotal={grandTotal}
            summary=""
          />
        )}

      </ReportContainer>

    </Box>
  );
}